export default [{
        "gaosudaima": "G15",
        "name": "深海高速",
        "qidian": "沈阳",
        "qita": "7201",
        "tingkao": "26443",
        "xuhao": "1",
        "zhongdian": "海口",
        "zhongshihua": "19059",
        "zhongshiyou": "183",
        "zouxiang": "南北"
    },
    {
        "gaosudaima": "G25",
        "name": "长深高速",
        "qidian": "长春",
        "qita": "93456",
        "tingkao": "133936",
        "xuhao": "2",
        "zhongdian": "深圳",
        "zhongshihua": "3570",
        "zhongshiyou": "36910",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G4",
        "name": "京港澳高速",
        "qidian": "北京",
        "qita": "2107",
        "tingkao": "18880",
        "xuhao": "3",
        "zhongdian": "香港、澳门",
        "zhongshihua": "2020",
        "zhongshiyou": "14753",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G3",
        "name": "京台高速",
        "qidian": "北京",
        "qita": "3075",
        "tingkao": "19148",
        "xuhao": "4",
        "zhongdian": "台北",
        "zhongshihua": "325",
        "zhongshiyou": "15748",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G42",
        "name": "沪蓉高速",
        "qidian": "上海",
        "qita": "1010",
        "tingkao": "26763",
        "xuhao": "5",
        "zhongdian": "成都",
        "zhongshihua": "6197",
        "zhongshiyou": "19556",
        "zouxiang": "东西"
    }, {
        "gaosudaima": "G2",
        "name": "京沪高速",
        "qidian": "北京",
        "qita": "2625",
        "tingkao": "18697",
        "xuhao": "6",
        "zhongdian": "上海",
        "zhongshihua": "84",
        "zhongshiyou": "15988",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G55",
        "name": "二广高速",
        "qidian": "二连浩特",
        "qita": "87",
        "tingkao": "6351",
        "xuhao": "7",
        "zhongdian": "广州",
        "zhongshihua": "1397",
        "zhongshiyou": "4867",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G60",
        "name": "沪昆高速",
        "qidian": "上海",
        "qita": "102",
        "tingkao": "73877",
        "xuhao": "8",
        "zhongdian": "昆明",
        "zhongshihua": "6052",
        "zhongshiyou": "67723",
        "zouxiang": "东西"
    }, {
        "gaosudaima": "G30",
        "name": "连霍高速",
        "qidian": "连云港",
        "qita": "24845",
        "tingkao": "55528",
        "xuhao": "9",
        "zhongdian": "霍尔果斯",
        "zhongshihua": "23297",
        "zhongshiyou": "7386",
        "zouxiang": "东西"
    }, {
        "gaosudaima": "G35",
        "name": "济广高速",
        "qidian": "济南",
        "qita": "1943",
        "tingkao": "21624",
        "xuhao": "10",
        "zhongdian": "广州",
        "zhongshihua": "545",
        "zhongshiyou": "19136",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G70",
        "name": "福银高速",
        "qidian": "福州",
        "qita": "4364",
        "tingkao": "22607",
        "xuhao": "11",
        "zhongdian": "银川",
        "zhongshihua": "2648",
        "zhongshiyou": "15595",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G50",
        "name": "沪渝高速",
        "qidian": "上海",
        "qita": "154",
        "tingkao": "42964",
        "xuhao": "12",
        "zhongdian": "重庆",
        "zhongshihua": "17944",
        "zhongshiyou": "24866",
        "zouxiang": "东西"
    }, {
        "gaosudaima": "G5",
        "name": "京昆高速",
        "qidian": "北京",
        "qita": "17312",
        "tingkao": "50868",
        "xuhao": "13",
        "zhongdian": "昆明",
        "zhongshihua": "26842",
        "zhongshiyou": "6714",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G20",
        "name": "青银高速",
        "qidian": "青岛",
        "qita": "29023",
        "tingkao": "43689",
        "xuhao": "14",
        "zhongdian": "银川",
        "zhongshihua": "147",
        "zhongshiyou": "14519",
        "zouxiang": "东西"
    }, {
        "gaosudaima": "G40",
        "name": "沪陕高速",
        "qidian": "上海",
        "qita": "3768",
        "tingkao": "11811",
        "xuhao": "15",
        "zhongdian": "西安",
        "zhongshihua": "3025",
        "zhongshiyou": "5018",
        "zouxiang": "东西"
    }, {
        "gaosudaima": "G22",
        "name": "青兰高速",
        "qidian": "青岛",
        "qita": "738",
        "tingkao": "8433",
        "xuhao": "16",
        "zhongdian": "兰州",
        "zhongshihua": "3468",
        "zhongshiyou": "4227",
        "zouxiang": "东西"
    }, {
        "gaosudaima": "G65",
        "name": "包茂高速",
        "qidian": "包头",
        "qita": "12569",
        "tingkao": "74087",
        "xuhao": "17",
        "zhongdian": "茂名",
        "zhongshihua": "24758",
        "zhongshiyou": "36760",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G18",
        "name": "荣乌高速",
        "qidian": "荣成",
        "qita": "109370",
        "tingkao": "112878",
        "xuhao": "18",
        "zhongdian": "乌海",
        "zhongshihua": "3184",
        "zhongshiyou": "324",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G1",
        "name": "京哈高速",
        "qidian": "北京",
        "qita": "6600",
        "tingkao": "32117",
        "xuhao": "19",
        "zhongdian": "哈尔滨",
        "zhongshihua": "21523",
        "zhongshiyou": "3994",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G75",
        "name": "兰海高速",
        "qidian": "兰州",
        "qita": "399",
        "tingkao": "30976",
        "xuhao": "20",
        "zhongdian": "海口",
        "zhongshihua": "13096",
        "zhongshiyou": "17481",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G1511",
        "name": "日兰高速",
        "qidian": "日照",
        "qita": "2023",
        "tingkao": "3877",
        "xuhao": "21",
        "zhongdian": "兰考",
        "zhongshihua": "170",
        "zhongshiyou": "1684",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G93",
        "name": "成渝环线",
        "qidian": "成都",
        "qita": "11526",
        "tingkao": "35669",
        "xuhao": "22",
        "zhongdian": "重庆",
        "zhongshihua": "11577",
        "zhongshiyou": "12566",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G6",
        "name": "京藏高速",
        "qidian": "北京",
        "qita": "561",
        "tingkao": "16755",
        "xuhao": "23",
        "zhongdian": "拉萨",
        "zhongshihua": "2305",
        "zhongshiyou": "13889",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G92",
        "name": "杭州湾环线",
        "qidian": "上海",
        "qita": "0",
        "tingkao": "12942",
        "xuhao": "24",
        "zhongdian": "宁波",
        "zhongshihua": "0",
        "zhongshiyou": "12942",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G72",
        "name": "泉南高速",
        "qidian": "泉州",
        "qita": "5338",
        "tingkao": "29058",
        "xuhao": "25",
        "zhongdian": "南宁",
        "zhongshihua": "11723",
        "zhongshiyou": "11997",
        "zouxiang": "东西"
    }, {
        "gaosudaima": "G9411",
        "name": "莞佛高速",
        "qidian": "东莞",
        "qita": "19",
        "tingkao": "531",
        "xuhao": "26",
        "zhongdian": "佛山",
        "zhongshihua": "69",
        "zhongshiyou": "443",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G107",
        "name": "107国道",
        "qidian": "北京",
        "qita": "263070",
        "tingkao": "485580",
        "xuhao": "27",
        "zhongdian": "深圳",
        "zhongshihua": "82519",
        "zhongshiyou": "139991",
        "zouxiang": "南北"
    }, {
        "gaosudaima": "G5512",
        "name": "晋新高速",
        "qidian": "晋城",
        "qita": "0",
        "tingkao": "264",
        "xuhao": "28",
        "zhongdian": "新乡",
        "zhongshihua": "0",
        "zhongshiyou": "264",
        "zouxiang": "南北"
    }
]